import { Badge } from "@mantine/core";
import { TemplateType } from "src/gql/graphql";
import { match } from "ts-pattern";

export const TemplateTypeBadge = (props: { type: TemplateType }) =>
    match(props.type)
        .with(TemplateType.Customer, () => <Badge color="blue">Template</Badge>)
        .with(TemplateType.Welcome, () => <Badge color="red">Welcome</Badge>)
        .with(TemplateType.Ipaws, () => <Badge color="violet">IPAWS</Badge>)
        .with(TemplateType.OptIn, () => <Badge color="orange">Opt In</Badge>)
        .exhaustive();
